import React from "react";
import { Form, Row, Col, Input, Select, Button, Tooltip, Divider, Table, Tabs, message, DatePicker, AutoComplete } from 'antd';
import CustomBadge from 'components/CustomBadge';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { Link } from 'react-router-dom';
import { CaretRightFilled } from '@ant-design/icons';
import AntDraggableModal from 'components/AntDraggableModal';
import moment from 'moment';

export default class AdvanceSearch extends React.Component {
  constructor(props) {
    super();
    this.state = {
      data: [],
      loaded: false,
      jobUieList: [],
      documentUieList: [],
      activeKey: 0,
      moduleData: [],
      workflowStatusData: [],
      contactTypeData: [],
      stateData: [],
      lgaData: [],
      clientData: [],
      companyOfficeData: [],
      labelGroupData: [],
      documentTypeData: [],
      companyUserData: [],
      pageConfig: {},
      allowAllModule: false,
      selectedModuleId: null,
      documentSearchBy: 'LP/PS',
      siteAddressOptions: [],
      siteAddressInput: '',
      jonId: null
    }

    this.jobFormRef = React.createRef();
    this.documentFormRef = React.createRef();
    this.siteAddressTimer = null;
  };

  searchAddressFromHyperFlo = (value) => {
    this.setState({ siteAddressInput: value });
    if (this.siteAddressTimer) {
      clearTimeout(this.siteAddressTimer);
    }
    this.siteAddressTimer = setTimeout(() => {
      let companyId = this.props.authUser.CompanyId;
      let moduleId = this.documentFormRef.current?.getFieldValue('ModuleId');
      if (!moduleId || (value || '').trim().length < 3) {
        this.setState({ siteAddressOptions: [] });
        return;
      }
      httpClient
        .get('/System/SearchAddress/GetAutoCompleteList?str=' + encodeURIComponent(value) + '&companyId=' + companyId + '&moduleId=' + moduleId)
        .then(({ data }) => {
          if (data.result) {
            let jobs = data.data;
            if (jobs.length > 0) {
              let addressList = [];
              jobs.map((item, i) => {
                let address = item.PptAddress.replace(new RegExp(value.toUpperCase(), 'g'), '<b>' + value.toUpperCase() + '</b>');
                if (!globalFunction.isNullOrEmpty(item.StageDesc)) {
                  address += '<br />' + item.StageDesc;
                }
                addressList.push({ label: <span key={i} dangerouslySetInnerHTML={{ __html: address }} />, value: item.PptAddress + ' (' + item.JobNum + ')', data: item, key: item.JobId });
              })
              this.setState({ siteAddressOptions: addressList });
            } else {
              this.setState({ siteAddressOptions: [] });
            }
          } else {
            this.setState({ siteAddressOptions: [] });
          }
        })
        .catch(() => {
          this.setState({ siteAddressOptions: [] });
        });
    }, 500);
  }

  selectAddressFromHyperFlo = (value, option) => {
    let job = option?.data;
    if (!job) return;
    this.setState({ siteAddressInput: job.PptAddress, jobId: job.JobId });
  }

  //查询该页面的数据
  componentDidMount() {
    if (this.props.authUser.CompanyId == 31) {
      this.setState({ allowAllModule: true });
    }

    let pageConfig = this.props.authUser.webUIConfig?.areaList?.filter(item => item.name === 'Business' && item.module === '')[0]?.pageList?.filter(item => item.name === 'AdvanceSearch')[0];
    let jobUieList = pageConfig?.sectionList?.filter(item => item.name === 'Job')[0]?.componentList[0]?.groupList[0]?.uieList;
    let documentUieList = pageConfig?.sectionList?.filter(item => item.name === 'Document')[0]?.componentList[0]?.groupList[0]?.uieList;
    //判断加载哪些Tab
    if (jobUieList !== undefined && jobUieList.length > 0) {
      this.setState({ jobUieList, documentUieList, activeKey: 0, pageConfig });
      this.getModuleData();
      this.getClientData();
      this.getCompanyOfficeData();
      this.getCompanyUserData();
    } else {
      this.setState({ jobUieList, documentUieList, activeKey: 1, pageConfig });
      this.getModuleData();
    }
  }

  getModuleData() {
    let that = this;
    httpClient
      .get('System/Module/GetSelectOptionList')
      .then(({ data }) => {
        if (data.result) {
          let moduleData = this.state.allowAllModule ? data.data : data.data.filter(item => item.Value !== 0);
          this.setState({ moduleData, selectedModuleId: moduleData[0]?.Value });
          setTimeout(() => {
            if (this.state.jobUieList !== undefined && this.state.jobUieList.length > 0) {
              this.jobFormRef.current?.setFieldsValue({ ModuleId: this.state.moduleData[0]?.Value, State: this.state.moduleData[0]?.Data });
              this.getWorkflowStatusData(this.state.moduleData[0]?.Value);
              this.getLabelGroupData(this.state.moduleData[0]?.Value);
              this.getContactTypeData(this.state.moduleData[0]?.Value);
              this.getStateData();
            }
            if (this.state.documentUieList !== undefined && this.state.documentUieList.length > 0) {
              this.documentFormRef.current?.setFieldsValue({ ModuleId: this.state.moduleData[0]?.Value });
              this.getDocumentTypeData(this.state.moduleData[0]?.Value);
            }
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, this.props.pageComponent);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that.props.pageComponent);
      });
  }

  getWorkflowStatusData(moduleId) {
    let that = this;
    httpClient
      .get('/Admin/WorkflowStatus/GetSelectOptionList?moduleId=' + moduleId)
      .then(({ data }) => {
        if (data.result) {
          this.setState({ workflowStatusData: data.data });
          setTimeout(() => {
            this.jobFormRef.current?.setFieldsValue({ WorkflowStatusId: this.state.workflowStatusData[0]?.Value });
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  getContactTypeData(moduleId) {
    let that = this;
    httpClient
      .get('/Admin/ContactType/GetSelectOptionList?moduleId=' + moduleId)
      .then(({ data }) => {
        if (data.result) {
          data.data[0].Key = '- Any Contact Type -';
          this.setState({ contactTypeData: data.data });
          setTimeout(() => {
            this.jobFormRef.current?.setFieldsValue({ ContactTypeId: this.state.contactTypeData[0]?.Value });
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  getLabelGroupData(moduleId) {
    let that = this;
    httpClient
      .get('/Admin/Label/GetGroupList?moduleId=' + moduleId)
      .then(({ data }) => {
        if (data.result) {
          this.setState({ labelGroupData: data.data || [] });
        } else {
          globalFunction.handleResultError(data, that);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  getStateData() {
    let that = this;
    httpClient
      .get('/System/SelectOption/GetStateList')
      .then(({ data }) => {
        if (data.result) {
          this.setState({ stateData: data.data });
          setTimeout(() => {
            this.getLgaData(this.jobFormRef.current?.getFieldValue('State'));
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  getLgaData(state) {
    let that = this;
    httpClient
      .get('Admin/Lga/GetSelectOptionList?state=' + state)
      .then(({ data }) => {
        if (data.result) {
          this.setState({ lgaData: data.data });
          setTimeout(() => {
            this.jobFormRef.current?.setFieldsValue({ LgaId: this.state.lgaData[0]?.Value });
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  getClientData() {
    let that = this;
    httpClient
      .get('Admin/Client/GetSelectOptionList')
      .then(({ data }) => {
        if (data.result) {
          this.setState({ clientData: data.data });
          setTimeout(() => {
            this.jobFormRef.current?.setFieldsValue({ ClientId: this.state.clientData[0]?.Value });
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  getCompanyOfficeData() {
    let that = this;
    httpClient
      .get('Admin/CompanyOffice/GetSelectOptionList')
      .then(({ data }) => {
        if (data.result) {
          this.setState({ companyOfficeData: data.data });
          setTimeout(() => {
            this.jobFormRef.current?.setFieldsValue({ CompanyOfficeId: this.state.companyOfficeData[0]?.Value });
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  getDocumentTypeData(moduleId) {
    let that = this;
    httpClient
      .get('Admin/DocumentType/GetSelectOptionList?moduleId=' + moduleId)
      .then(({ data }) => {
        if (data.result) {
          this.setState({ documentTypeData: data.data });
          setTimeout(() => {
            this.documentFormRef.current?.setFieldsValue({ DocumentTypeId: this.state.documentTypeData[0]?.Value });
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  getCompanyUserData() {
    let that = this;
    httpClient
      .get('/Admin/CompanyUser/GetSelectOptionList')
      .then(({ data }) => {
        if (data.result) {
          this.setState({ companyUserData: data.data });
          setTimeout(() => {
            this.jobFormRef.current?.setFieldsValue({ AssignedUserId: this.state.companyUserData[0]?.Value, AssessingUserId: this.state.companyUserData[0]?.Value, SignoffUserId: this.state.companyUserData[0]?.Value, JobCompanyUserId: this.state.companyUserData[0]?.Value });
          }, config.setTimeoutMilliSecond);
        } else {
          globalFunction.handleResultError(data, this);
        }
      })
      .catch(function (error) {
        globalFunction.handleError(error, that);
      });
  }

  //提交表单
  onFinish = async (values: any) => {
    if (values.JobContactName?.length > 0 && values.JobContactName?.length < 3) {
      message.info('Please enter at least 3 characters for job contact search.');
      return;
    }
    if (this.state.activeKey === 1 && this.state.documentSearchBy === 'Site Address') {
      if (!this.state.jobId) {
        message.info('Please select an address from the suggestion list.');
        return;
      }
      values.JobId = this.state.jobId;
      delete values.PptLpps;
    }

    // Advanced Search 仍复用 Job 列表页展示，但由后端走独立查询逻辑。
    let queryParts = ['advancedSearch=true'];
    for (const [key, value] of Object.entries(values)) {
      if (key === 'DateCreated' && value !== undefined) {
        queryParts.push(`${encodeURIComponent('DateStart')}=${encodeURIComponent(moment(value[0]).format(config.format.sqlDate))}`);
        queryParts.push(`${encodeURIComponent('DateEnd')}=${encodeURIComponent(moment(value[1]).format(config.format.sqlDate))}`);
      } else {
        if (value !== undefined) {
          // ParameterModel.label 接收逗号分隔的 LabelId。
          const queryKey = key === 'Label' ? 'label' : key;
          const queryValue = key === 'Label' && Array.isArray(value) ? value.join(',') : value;
          queryParts.push(`${encodeURIComponent(queryKey)}=${encodeURIComponent(queryValue)}`);
        }
      }
    }
    let queryString = `${queryParts.join('&')}`;
    switch (this.state.activeKey) {
      case 0:
        this.props.history.push('/jobs?' + queryString);
        break;
      case 1:
        this.props.history.push('/documents?' + queryString);
        break;
    }
    this.props.setShowAdvancedSearch(false);
  };

  //提交表单之前验证失败
  onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  getTabItem() {
    let tabItems = [];
    if (this.state.jobUieList !== undefined && this.state.jobUieList.length > 0) {
      tabItems.push({
        label: <>{this.state.pageConfig?.sectionList?.filter(item => item.name === 'Job')[0]?.id != null ? <>{this.state.pageConfig?.sectionList?.filter(item => item.name === 'Job')[0]?.id}</> : <>Job</>}</>,
        key: 0,
        forceRender: true,
        children: <>
          <Form
            ref={this.jobFormRef}
            autoComplete="off"
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
            size={config.component.size}
          >
            <Row gutter={config.component.gutter}>
              {
                this.state.jobUieList.filter(uie => uie.source === 'Module').length > 0 ?
                  <Col span={24}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'Module')[0].title}
                      labelCol={{ span: 3 }}
                      wrapperCol={{ span: 21 }}
                      name="ModuleId"
                    >
                      <Select
                        bordered={config.component.bordered}
                        size={config.component.size}
                        showSearch
                        filterOption={(inputValue, option) => {
                          return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                        onChange={(value) => {
                          this.setState({ selectedModuleId: value });
                          this.getWorkflowStatusData(value);
                          this.getLabelGroupData(value);
                          this.jobFormRef.current?.setFieldsValue({ Label: [] });
                          this.getContactTypeData(value);
                          let state = this.state.moduleData.filter(item => item.Value === value)[0].Data;
                          this.jobFormRef.current?.setFieldsValue({ State: state });
                          this.getLgaData(state);
                        }}
                      >
                        {
                          this.state.moduleData.map((option, i) =>
                            <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                          )
                        }
                      </Select>
                    </Form.Item>
                  </Col> : <></>
              }           
              {
                this.state.jobUieList.filter(uie => uie.source === 'WorkflowStatus').length > 0 ?
                  <Col span={24}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'WorkflowStatus')[0].title}
                      labelCol={{ span: 3 }}
                      wrapperCol={{ span: 21 }}
                      name="WorkflowStatusId"
                    >
                      <Select
                        bordered={config.component.bordered}
                        size={config.component.size}
                        showSearch
                        filterOption={(inputValue, option) => {
                          return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                      >
                        {
                          this.state.workflowStatusData.map((option, i) =>
                            <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                          )
                        }
                      </Select>
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'JobContact').length > 0 ?
                  <>
                    <Col span={12}>
                      <Form.Item
                        label={this.state.jobUieList.filter(uie => uie.source === 'JobContact')[0].title}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                        name="ContactTypeId"
                      >
                        <Select
                          bordered={config.component.bordered}
                          size={config.component.size}
                          showSearch
                          filterOption={(inputValue, option) => {
                            return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                          }}
                        >
                          {
                            this.state.contactTypeData.map((option, i) =>
                              <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                            )
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label=""
                        labelCol={{ span: 0 }}
                        wrapperCol={{ span: 24 }}
                        name="JobContactName"
                      >
                        <Input
                          bordered={config.component.bordered}
                          maxLength={255}
                          size={config.component.size}
                          placeholder="Search first name, last name, company, email or mobile, please enter at least 3 characters"
                        />
                      </Form.Item>
                    </Col>
                  </> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'WorkDescription').length > 0 ?
                  <Col span={24}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'WorkDescription')[0].title}
                      labelCol={{ span: 3 }}
                      wrapperCol={{ span: 21 }}
                      name="WorkDescription"
                    >
                      <Input
                        bordered={config.component.bordered}
                        maxLength={255}
                        size={config.component.size}
                        placeholder="Enter nature of work"
                      />
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'BuildingName').length > 0 ?
                  <Col span={24}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'BuildingName')[0].title}
                      labelCol={{ span: 3 }}
                      wrapperCol={{ span: 21 }}
                      name="BuildingName"
                    >
                      <Input
                        bordered={config.component.bordered}
                        maxLength={255}
                        size={config.component.size}
                        placeholder="Enter building name"
                      />
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'Name').length > 0 ?
                  <Col span={24}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'Name')[0].title}
                      labelCol={{ span: 3 }}
                      wrapperCol={{ span: 21 }}
                      name="Name"
                    >
                      <Input
                        bordered={config.component.bordered}
                        maxLength={255}
                        size={config.component.size}
                      // placeholder={'Enter ' + this.state.jobUieList.filter(uie => uie.source === 'ProjectName')[0].title}
                      />
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'JobDescription').length > 0 ?
                  <Col span={24}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'JobDescription')[0].title}
                      labelCol={{ span: 3 }}
                      wrapperCol={{ span: 21 }}
                      name="JobDescription"
                    >
                      <Input
                        bordered={config.component.bordered}
                        maxLength={255}
                        size={config.component.size}
                      />
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'Lga').length > 0 ?
                  <>
                    <Col span={12}>
                      <Form.Item
                        label={this.state.jobUieList.filter(uie => uie.source === 'Lga')[0].title}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                        name="State"
                      >
                        <Select
                          bordered={config.component.bordered}
                          size={config.component.size}
                          showSearch
                          filterOption={(inputValue, option) => {
                            return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                          }}
                          onChange={(value) => {
                            this.getLgaData(value);
                          }}
                        >
                          {
                            this.state.stateData.map((option, i) =>
                              <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                            )
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col span={12}>
                      <Form.Item
                        label=""
                        labelCol={{ span: 0 }}
                        wrapperCol={{ span: 24 }}
                        name="LgaId"
                      >
                        <Select
                          bordered={config.component.bordered}
                          size={config.component.size}
                          showSearch
                          filterOption={(inputValue, option) => {
                            return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                          }}
                        >
                          {
                            this.state.lgaData.map((option, i) =>
                              <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                            )
                          }
                        </Select>
                      </Form.Item>
                    </Col>
                  </> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'DateCreated').length > 0 ?
                  <>
                    <Col span={12}>
                      <Form.Item
                        label={this.state.jobUieList.filter(uie => uie.source === 'DateCreated')[0].title}
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 18 }}
                        name="DateCreated"
                      >
                        <DatePicker.RangePicker
                          ranges={{
                            'This Month': [moment().startOf('month'), moment().endOf('month')],
                            'Last Month': [moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')],
                            'This Year': [moment().startOf('year'), moment().endOf('year')],
                            'Last Year': [moment().subtract(1, 'years').startOf('year'), moment().subtract(1, 'years').endOf('year')],
                          }}
                          bordered={config.component.bordered}
                          size={config.component.size}
                          style={{ width: '100%' }}
                          format={config.component.DatePicker.dateFormat}
                        />
                      </Form.Item>
                    </Col>
                  </> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'Client').length > 0 ?
                  <Col span={12}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'Client')[0].title}
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      name="ClientId"
                    >
                      <Select
                        bordered={config.component.bordered}
                        size={config.component.size}
                        showSearch
                        filterOption={(inputValue, option) => {
                          return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                      >
                        {
                          this.state.clientData.map((option, i) =>
                            <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                          )
                        }
                      </Select>
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'CompanyOffice').length > 0 ?
                  <Col span={12}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'CompanyOffice')[0].title}
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      name="CompanyOfficeId"
                    >
                      <Select
                        bordered={config.component.bordered}
                        size={config.component.size}
                        showSearch
                        filterOption={(inputValue, option) => {
                          return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                      >
                        {
                          this.state.companyOfficeData.map((option, i) =>
                            <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                          )
                        }
                      </Select>
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'ApplicationNo').length > 0 ?
                  <Col span={12}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'ApplicationNo')[0].title}
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      name="ApplicationNo"
                    >
                      <Input
                        bordered={config.component.bordered}
                        size={config.component.size}
                        placeholder="Enter council application number"
                      />
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'Label').length > 0 ?
                  <Col span={12}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'Label')[0].title}
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      name="Label"
                    >
                      <Select
                        mode="multiple"
                        bordered={config.component.bordered}
                        size={config.component.size}
                        showSearch
                        optionFilterProp="children"
                        placeholder="Select labels"
                        maxTagCount="responsive"
                      >
                        {this.state.labelGroupData.map((group, i) => {
                          const labels = (group.DataList || []).filter(label => label.Inactive !== true);
                          return labels.length > 0 ?
                            <Select.OptGroup key={group.key || i} label={group.Name}>
                              {labels.map(label =>
                                <Select.Option key={label.LabelId} value={label.LabelId}>{label.Name}</Select.Option>
                              )}
                            </Select.OptGroup> : null;
                        })}
                      </Select>
                    </Form.Item>
                  </Col> : <></>
              }
              {this.state.jobUieList.filter(uie => uie.source === 'AssignedUser').length > 0 || this.state.jobUieList.filter(uie => uie.source === 'AssessingUser').length > 0 || this.state.jobUieList.filter(uie => uie.source === 'SignoffUser').length > 0 || this.state.jobUieList.filter(uie => uie.source === 'JobCompanyUserId' && uie.show !== false).length > 0 ? <Divider orientation="left">By User</Divider> : <></>}
              {
                this.state.jobUieList.filter(uie => uie.source === 'AssignedUser').length > 0 ?
                  <Col span={12}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'AssignedUser')[0].title}
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      name="AssignedUserId"
                    >
                      <Select
                        bordered={config.component.bordered}
                        size={config.component.size}
                        showSearch
                        filterOption={(inputValue, option) => {
                          return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                      >
                        {
                          this.state.companyUserData.map((option, i) =>
                            <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                          )
                        }
                      </Select>
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'AssessingUser').length > 0 ?
                  <Col span={12}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'AssessingUser')[0].title}
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      name="AssessingUserId"
                    >
                      <Select
                        bordered={config.component.bordered}
                        size={config.component.size}
                        showSearch
                        filterOption={(inputValue, option) => {
                          return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                      >
                        {
                          this.state.companyUserData.map((option, i) =>
                            <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                          )
                        }
                      </Select>
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'SignoffUser').length > 0 ?
                  <Col span={12}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'SignoffUser')[0].title}
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      name="SignoffUserId"
                    >
                      <Select
                        bordered={config.component.bordered}
                        size={config.component.size}
                        showSearch
                        filterOption={(inputValue, option) => {
                          return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                      >
                        {
                          this.state.companyUserData.map((option, i) =>
                            <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                          )
                        }
                      </Select>
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.jobUieList.filter(uie => uie.source === 'JobCompanyUserId' && uie.show !== false).length > 0 ?
                  <Col span={12}>
                    <Form.Item
                      label={this.state.jobUieList.filter(uie => uie.source === 'JobCompanyUserId' && uie.show !== false)[0].title}
                      labelCol={{ span: 6 }}
                      wrapperCol={{ span: 18 }}
                      name="JobCompanyUserId"
                    >
                      <Select
                        bordered={config.component.bordered}
                        size={config.component.size}
                        showSearch
                        filterOption={(inputValue, option) => {
                          return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                      >
                        {
                          this.state.companyUserData.map((option, i) =>
                            <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                          )
                        }
                      </Select>
                    </Form.Item>
                  </Col> : <></>
              }
            </Row>
          </Form>
        </>
      });
    }
    if (this.state.documentUieList !== undefined && this.state.documentUieList.length > 0) {
      tabItems.push({
        label: <>{this.state.pageConfig?.sectionList?.filter(item => item.name === 'Document')[0]?.id != null ? <>{this.state.pageConfig?.sectionList?.filter(item => item.name === 'Document')[0]?.id}</> : <>Document</>}</>,
        key: 1,
        forceRender: true,
        children: <>
          <Form
            ref={this.documentFormRef}
            autoComplete="off"
            onFinish={this.onFinish}
            onFinishFailed={this.onFinishFailed}
            size={config.component.size}
          >
            <Row gutter={config.component.gutter}>
              {
                this.state.documentUieList.filter(uie => uie.source === 'PptLpps').length > 0 ?
                  <Col span={24}>
                    <Form.Item
                      label="Search By"
                      labelCol={{ span: 3 }}
                      wrapperCol={{ span: 21 }}
                    >
                      <Input.Group compact style={{ display: 'flex', width: '100%' }}>
                        <Select
                          bordered={config.component.bordered}
                          size={config.component.size}
                          value={this.state.documentSearchBy}
                          onChange={(value) => {
                            this.documentFormRef.current?.setFieldsValue({ PptLpps: undefined });
                            this.setState({ documentSearchBy: value, siteAddressInput: '', siteAddressOptions: [], jobId: null });
                          }}
                          style={{ width: 160, flex: '0 0 160px' }}
                          options={[
                            { value: 'LP/PS', label: 'LP/PS' },
                            { value: 'Site Address', label: 'Site Address' },
                          ]}
                        />
                        {
                          this.state.documentSearchBy === 'LP/PS' ?
                            <Form.Item
                              name="PptLpps"
                              noStyle
                              rules={[{ required: true, message: '' }]}
                            >
                              <Input
                                bordered={config.component.bordered}
                                maxLength={255}
                                size={config.component.size}
                                placeholder="Property Lpps number"
                                style={{ flex: 1 }}
                              />
                            </Form.Item>
                            :
                            <AutoComplete
                              bordered={config.component.bordered}
                              size={config.component.size}
                              value={this.state.siteAddressInput}
                              options={this.state.siteAddressOptions}
                              onSearch={this.searchAddressFromHyperFlo}
                              onChange={(value, option) => { this.setState({ siteAddressInput: value, jobId: option.key }); }}
                              onSelect={this.selectAddressFromHyperFlo}
                              placeholder="Type at least 3 characters to search address"
                              style={{ flex: 1 }}
                            />
                        }
                      </Input.Group>
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.documentUieList.filter(uie => uie.source === 'Module').length > 0 ?
                  <Col span={24}>
                    <Form.Item
                      label={this.state.documentUieList.filter(uie => uie.source === 'Module')[0].title}
                      labelCol={{ span: 3 }}
                      wrapperCol={{ span: 21 }}
                      name="ModuleId"
                    >
                      <Select
                        bordered={config.component.bordered}
                        size={config.component.size}
                        showSearch
                        filterOption={(inputValue, option) => {
                          return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                        onChange={(value) => {
                          this.getDocumentTypeData(value);
                        }}
                      >
                        {
                          this.state.moduleData.map((option, i) =>
                            <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                          )
                        }
                      </Select>
                    </Form.Item>
                  </Col> : <></>
              }
              {
                this.state.documentUieList.filter(uie => uie.source === 'DocumentType').length > 0 ?
                  <Col span={24}>
                    <Form.Item
                      label={this.state.documentUieList.filter(uie => uie.source === 'DocumentType')[0].title}
                      labelCol={{ span: 3 }}
                      wrapperCol={{ span: 21 }}
                      name="DocumentTypeId"
                    >
                      <Select
                        bordered={config.component.bordered}
                        size={config.component.size}
                        showSearch
                        filterOption={(inputValue, option) => {
                          return option?.children?.toLowerCase().includes(inputValue.toLowerCase());
                        }}
                      >
                        {
                          this.state.documentTypeData.map((option, i) =>
                            <Select.Option key={option.Value} value={option.Value}>{option.Key}</Select.Option>
                          )
                        }
                      </Select>
                    </Form.Item>
                  </Col> : <></>
              }
            </Row>
          </Form>
        </>
      });
    }
    return tabItems;
  }

  render() {
    return (
      <AntDraggableModal
        title="Advanced Search"
        open={true}
        onOk={() => {
          switch (this.state.activeKey) {
            case 0:
              this.jobFormRef.current?.submit();
              break;
            case 1:
              this.documentFormRef.current?.submit();
              break;
          }
        }}
        onCancel={() => {
          this.props.setShowAdvancedSearch(false);
        }}
        width={1200}
        okText="Search"
        maskClosable={config.component.Modal.maskClosable}
      >
        <Tabs
          activeKey={this.state.activeKey}
          type="card"
          size="small"
          items={this.getTabItem()}
          onChange={(activeKey) => { this.setState({ activeKey }); }}
        />
      </AntDraggableModal>
    );
  }
}
